'use client';

import { useEffect } from 'react';

const ServiceWorkerRegistration = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js')?.then((registration) => {
            console.log('SW registered:', registration?.scope);
            registration?.addEventListener('updatefound', () => {
              const newWorker = registration?.installing;
              if (newWorker) {
                newWorker?.addEventListener('statechange', () => {
                  if (newWorker?.state === 'installed' && navigator.serviceWorker?.controller) {
                    console.log('New content available, refresh to update.');
                  }
                });
              }
            });
          })?.catch((err) => {
            console.log('SW registration failed:', err);
          });
      });
    }
  }, []);

  return null;
};

export default ServiceWorkerRegistration;
